import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { HandoffQr } from './HandoffQr';
import { StoreBadges } from './StoreBadges';
import { EmailLinkButton } from './EmailLinkButton';
import { withBrandWord } from '../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole handoff; each part uses its own slice of it */
import styles from './MobileApps.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MobileAppHandoffProps {
  lead: string;
  /** The app path the phone opens. The app's start screen when not set. */
  next?: string;
  /** The steps (1a) or the benefit rows (1b). */
  children: React.ReactNode;
  /** The waiting row (1a) or nothing (1b). */
  footer?: React.ReactNode;
}

/**
 * The handoff card (design music24-mobile-apps 1a, 1b): a QR code with the handoff link, the
 * steps or benefits, the store badges and "Email me the link". The host modal draws the title.
 */
const MobileAppHandoffComponent: React.FC<MobileAppHandoffProps> = ({ lead, next, children, footer }) => {
  const intl = useIntl();

  return (
    <div className={styles.handoff}>
      <p className={styles.lead}>{withBrandWord(lead)}</p>
      <div className={styles.body}>
        <HandoffQr next={next} />
        <div className={styles.side}>
          {children}
          <div className={styles.or}>
            {intl.formatMessage({ id: 'app.sml.mobileApps.orStore', defaultMessage: 'or get the app from the store' })}
          </div>
          <StoreBadges next={next} />
          <EmailLinkButton next={next} />
        </div>
      </div>
      {footer}
    </div>
  );
};

export const MobileAppHandoff = TypedMemo(MobileAppHandoffComponent);
